import store from '@/state/store';
import { update } from '@/api/project';
import projectSlice from '@/state/project.slice';
import { handleError } from '@/actions/common';
import { ProjectUpdateData } from '@bimdata/definitions/dto';

export default async (code: string, data: ProjectUpdateData): Promise<void> => {
  if (
    data.name === undefined
    && data.revit3DView === undefined
    && data.additionalSections === undefined
    && data.importRevitEdges === undefined
  ) return;
  try {
    await update(code, data);
    store.dispatch(
      projectSlice.actions.update({ code, data })
    );
  } catch (error) {
    handleError(error);
  }
};
